<template>
  <div>
    <div class="p-6 pb-0">
      <BreadCrumbs :navigation="navigation" />
    </div>
    <div class="p-6 pb-0">
      <div class="flex items-center gap-4 mb-4">
        <input 
          v-model="searchTerm" 
          @keyup.enter="performSearch"
          @blur="performSearch"
          type="text" 
          placeholder="Ricerca codice/ragione sociale" 
          class="p93__input_general px-4 py-2 min-w-[260px]" 
        />
        <select v-model="agent" @change="performSearch" class="p93__input_general bg-white px-4 py-2 disabled:bg-gray-100" name="agent" required :disabled="fixedAgent">
          <option value="">Scegli l'agente</option>
          <option v-for="agent in salesPeople" :key="agent.id" :value="agent.id">{{ agent.name }}</option>
        </select>
        <label class="flex items-center cursor-pointer">
            <input v-model="showZeroBalances" @change="performSearch" type="checkbox" class="sr-only" />
            <div class="relative">
                <div :class="showZeroBalances ? 'bg-green-500' : 'bg-gray-600'"
                    class="block w-14 h-8 rounded-full transition-colors"></div>
                <div :class="showZeroBalances ? 'translate-x-6' : 'translate-x-0'"
                    class="absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition"></div>
            </div>
            <span class="ml-2 text-sm">Visualizza saldi a zero</span>
        </label>
      </div>
      <table class="min-w-full bg-white rounded-md shadow-lg">
        <thead>
          <tr>
            <SortableTableHeader 
              title="ID" 
              field="CustSupp" 
              :currentSortField="sortField" 
              :sortDirection="sortDirection" 
              @sort="sort" 
            />
            <SortableTableHeader 
              title="Ragione sociale" 
              field="CompanyName" 
              :currentSortField="sortField" 
              :sortDirection="sortDirection" 
              :isDefault="true"
              @sort="sort" 
            />
            <th class="py-2 px-4 border-b text-right">Saldo</th>
            <th class="py-2 px-4 border-b text-right">Totale a scadere</th>
            <th class="py-2 px-4 border-b text-right">Totale scaduto</th>
            <th class="py-2 px-4 border-b text-right">Note credito attive</th>
            <th class="py-2 px-4 border-b text-right">Note credito scadute</th>
            <th class="py-2 px-4 border-b text-center">Azioni</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="estrattoConto in estrattiContoClienti.data" :key="estrattoConto.id" class="text-sm">
            <td class="py-2 px-4 border-b text-left">{{ estrattoConto.CustSupp }}</td>
            <td class="py-2 px-4 border-b text-left">{{ estrattoConto.CompanyName }}</td>
            <td class="py-2 px-4 border-b text-right">{{ formatCurrency(estrattoConto.TotaleDaPagare - estrattoConto.TotaleNC) }}</td>
            <td class="py-2 px-4 border-b text-right">{{ formatCurrency(estrattoConto.TotaleDaPagare - estrattoConto.TotaleScaduto) }}</td>
            <td class="py-2 px-4 border-b text-right">{{ formatCurrency(estrattoConto.TotaleScaduto) }}</td>
            <td class="py-2 px-4 border-b text-right">{{ formatCurrency(estrattoConto.TotaleNC - estrattoConto.TotaleNCScadute) }}</td>
            <td class="py-2 px-4 border-b text-right">{{ formatCurrency(estrattoConto.TotaleNCScadute) }}</td>
            <td class="py-2 px-4 border-b text-center">
              <button @click="dettagli(estrattoConto.CustSupp)" class="bg-green-500 text-white px-2 py-1 rounded-md mr-2">Dettagli</button>
            </td>
          </tr>
          <tr>
            <td class="text-left" colspan="8"><Pagination :links="estrattiContoClienti.links" /></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Link, router, useForm } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Pagination from '@/Components/Pagination.vue';
import SortableTableHeader from '@/Components/SortableTableHeader.vue';
import currencyMixin from '@/mixins/currencyMixin.js';

export default {
  mixins: [currencyMixin],
  props: ['estrattiContoClienti', 'errors', 'sort', 'direction', 'search', 'salesPeople', 'startAgent', 'fixedAgent'],
  components: {
    Link,
    BreadCrumbs,
    Pagination,
    SortableTableHeader
  },
  data() {
    return {
      agent: '',
      sortField: this.sort,
      sortDirection: this.direction || 'asc',
      searchTerm: this.search || '',
      showZeroBalances: false,
      navigation: [
        { name: 'Dashboard', href: route('dashboard') },
        { name: 'Estratto conto', href: route('modules.home', 'estratto-conto') }
      ]
    };
  },
  methods: {
    sort(field) {
      if (this.sortField === field) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortField = field;
        this.sortDirection = 'asc';
      }
      this.performSearch();
    },
    performSearch() {
      router.get(route('modules.home', 'estratto-conto'), {
        search: this.searchTerm,
        agent: this.agent,
        showZeroBalances: this.showZeroBalances,
        sort: this.sortField || 'CompanyName',
        direction: this.sortDirection || 'asc'
      }, { preserveState: true, replace: true });
    },
    dettagli(custSupp) {
      router.get(route('modules.estratto-conto.dettagli', custSupp), {}, { preserveState: true, replace: true });
    } 
  },
  mounted() {
    this.agent = this.startAgent || '';
  }
};
</script>